import { render, staticRenderFns } from "./aiDialog.vue?vue&type=template&id=7c4b4522&scoped=true"
import script from "./aiDialog.vue?vue&type=script&lang=js"
export * from "./aiDialog.vue?vue&type=script&lang=js"
import style0 from "./aiDialog.vue?vue&type=style&index=0&id=7c4b4522&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c4b4522",
  null
  
)

export default component.exports